// @flow
import React from 'react';
import Tooltip from '@homeaway/react-tooltip';

import type {BadgeShape as Badge} from '../Hit/Hit';

import './WebRatingBadge.less';

type WebRatingBadgesProps = {
    badge: Badge,
    renderTooltip?: boolean
};

export default function WebRatingBadge({
    badge,
    renderTooltip = false
}: WebRatingBadgesProps) {
    return (
        <span className="WebRatingBadge">
            {renderTooltip ? (
                <Tooltip
                    wrapperClassName="WebRatingBadge"
                    centered
                    trigger="hover"
                    tooltipType="popover"
                    content={badge.helpText}
                    placement="top"
                >
                    {badge.name}
                </Tooltip>
            ) : (
                badge.name
            )}
        </span>
    );
}
